import { forwardRef, useMemo, useState } from "react";
import { fold } from "./cargoSlots";

// Diacritic-insensitive street hints: "luk" → "Łukasińskiego". Matches the start of any word in the street name.
export const StreetSuggest = forwardRef(({ value, onChange, streets, className, ...rest }, ref) => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(0);
  const query = fold(value).trim();
  const hints = useMemo(() => {
    if (!query || /\d/.test(query)) return [];
    return streets
      .map((s) => ({ s, f: fold(s) }))
      .filter(({ f }) => f !== query && (f.startsWith(query) || f.split(/[\s.-]+/).some((w) => w.startsWith(query))))
      .sort((a, b) => Number(!a.f.startsWith(query)) - Number(!b.f.startsWith(query)) || a.s.localeCompare(b.s, "pl"))
      .slice(0, 8).map(({ s }) => s);
  }, [query, streets]);
  const pick = (street) => { onChange(`${street} `); setOpen(false); setActive(0); };
  const onKeyDown = (e) => {
    if (!open || !hints.length) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setActive((active + 1) % hints.length); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setActive((active - 1 + hints.length) % hints.length); }
    else if (e.key === "Enter" || e.key === "Tab") { e.preventDefault(); pick(hints[active] || hints[0]); }
    else if (e.key === "Escape") setOpen(false);
  };
  return (
    <div className="relative">
      <input ref={ref} {...rest} value={value} autoComplete="off" onKeyDown={onKeyDown} onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)} onChange={(e) => { onChange(e.target.value); setOpen(true); setActive(0); }} className={className} />
      {open && hints.length > 0 && (
        <ul data-testid="street-suggestions" role="listbox" className="absolute z-30 left-0 right-0 mt-1 rounded-xl bg-white shadow-xl ring-1 ring-zinc-200 overflow-hidden">
          {hints.map((s, i) => (
            <li key={s} role="option" aria-selected={i === active}>
              <button type="button" data-testid={`street-suggestion-${i}`} onMouseDown={(e) => { e.preventDefault(); pick(s); }} className={`w-full text-left px-3 py-2.5 text-sm font-semibold transition-colors ${i === active ? "bg-orange-50 text-orange-800" : "hover:bg-zinc-50"}`}>{s}</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
});
